module.exports = __webpack_public_path__ + "static/media/icon_rut.1289de7c.svg";